export function register() {
  if (process.env.NODE_ENV === 'development') {
    const originalError = console.error.bind(console)
    console.error = (...args: unknown[]) => {
      // Suppress Mantine CSS selector syntax warnings e.g. "&[data-active]"
      // React flags these as unsupported style properties in dev mode.
      const msg = typeof args[0] === 'string' ? args[0] : ''
      const prop = typeof args[1] === 'string' ? args[1] : ''
      if (
        msg.includes('Unsupported style property') &&
        (msg.includes('&[') || prop.startsWith('&['))
      ) {
        return
      }
      originalError(...args)
    }
  }
}
